import { FC, useEffect, useState } from 'react';
import { AgentType, StreamPhase } from '@/types/agents';

const STATES_BY_TYPE: Record<AgentType, string[]> = {
  SQL: ['Gerando SQL…', 'Executando consulta…', 'Formatando resposta…'],
  RAG: ['Buscando nos documentos…', 'Analisando trechos relevantes…', 'Formulando resposta…'],
};

const PHASE_LABELS: Record<StreamPhase, string> = {
  embed: 'Lendo sua pergunta…',
  search: 'Buscando nos documentos…',
  llm_start: 'Formulando resposta…',
};

interface ThinkingIndicatorProps {
  type?: AgentType;
  /** Quando vier, sobrescreve a rotação por timer e mostra a fase real do stream. */
  phase?: StreamPhase;
}

const ThinkingIndicator: FC<ThinkingIndicatorProps> = ({ type = 'RAG', phase }) => {
  const states = STATES_BY_TYPE[type] ?? STATES_BY_TYPE.RAG;
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (phase) return; // sem timer quando a fase real está dirigindo
    setIdx(0);
    const interval = window.setInterval(() => setIdx((i) => (i + 1) % states.length), 1500);
    return () => window.clearInterval(interval);
  }, [states, phase]);

  const label = phase ? PHASE_LABELS[phase] : states[idx];

  return (
    <div data-testid="thinking-indicator" className="flex items-center gap-2 text-content-tertiary text-sm py-2 px-4">
      <span className="inline-flex gap-1">
        <span className="w-1.5 h-1.5 bg-accent rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
        <span className="w-1.5 h-1.5 bg-accent rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
        <span className="w-1.5 h-1.5 bg-accent rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
      </span>
      <span>{label}</span>
    </div>
  );
};

export default ThinkingIndicator;
